import '../../../node_modules/vt-frontend-engine/app/scripts/main';

import './vendor/flashcards.js';

import './components/matho/matho.js';

import './components/math-memory/memory-games.js';

import './components/hidden-picture/component.js';

import './vendor/orderofoperations.src';

import './components/worksheets/component.js';

import './components/word-find/word-find.js';

import './components/addition-helper/addition-helper.js';

import './components/inequality/component.js';

import './components/money/component.js';

import './components/algebra/component.js';

import './components/flashcard-creator/component.js';



/** WEBPACK FOOTER **
 ** ./client/app/scripts/main.js
 **/